/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneRowActionsSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-ROW-001
 * PURPOSE: Long-press / More row menu from qaChecklistRowMenu, as sheet buttons.
 */
import { MobileSheet } from '@quotech/ui'
import { QaInlineMenuButtons } from '../../../../qa/qaInlineMenuButtons'
import { buildQaChecklistRowMenu } from '../../../../qa/qaChecklistRowMenu'
import { QA_PHONE_CONTROLS } from '../qaPhoneControlInventory'

export function QaPhoneRowActionsSheet({
  open,
  onClose,
  locked,
  isFirst,
  isLast,
  hasHold,
  needsSignoff,
  onInsertAbove,
  onInsertBelow,
  onInsertSubRow,
  onDuplicate,
  onToggleHold,
  onToggleSignoff,
  onMoveUp,
  onMoveDown,
  onDelete,
  onCopy,
  onPasteAbove,
  onPasteBelow,
  onUndo,
  onRedo,
  copyCount,
  pasteLabel,
}: {
  open: boolean
  onClose: () => void
  locked: boolean
  isFirst: boolean
  isLast: boolean
  hasHold: boolean
  needsSignoff?: boolean
  onInsertAbove: () => void
  onInsertBelow: () => void
  onInsertSubRow: () => void
  onDuplicate: () => void
  onToggleHold: () => void
  onToggleSignoff?: () => void
  onMoveUp: () => void
  onMoveDown: () => void
  onDelete: () => void
  onCopy?: () => void
  onPasteAbove?: () => void
  onPasteBelow?: () => void
  onUndo?: () => void
  onRedo?: () => void
  copyCount?: number
  pasteLabel?: string | null
}) {
  const items = buildQaChecklistRowMenu(
    { isFirst, isLast, hasHold, needsSignoff, disabled: locked, copyCount, pasteLabel },
    {
      onInsertAbove,
      onInsertBelow,
      onInsertSubRow,
      onDuplicate,
      onToggleHold,
      onToggleSignoff,
      onMoveUp,
      onMoveDown,
      onDelete,
      onCopy,
      onPasteAbove,
      onPasteBelow,
      onUndo,
      onRedo,
    },
  )
  return (
    <MobileSheet open={open} onClose={onClose} title="Row actions" size="full">
      <QaInlineMenuButtons
        items={items}
        onDone={onClose}
        className="py-1"
        control={QA_PHONE_CONTROLS.rowActions}
      />
    </MobileSheet>
  )
}
